import { render, staticRenderFns } from "./TqSharesButtons.vue?vue&type=template&id=5283c235&scoped=true&"
import script from "./TqSharesButtons.vue?vue&type=script&lang=js&"
export * from "./TqSharesButtons.vue?vue&type=script&lang=js&"
import style0 from "./TqSharesButtons.vue?vue&type=style&index=0&id=5283c235&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5283c235",
  null
  
)

export default component.exports